import { gql } from '@apollo/client'

export const PROCESSING_TYPES_QUERY = gql`
  query processingTypes(
    $sortBy: ProcessingTypeSort
    $filter: ProcessingTypeFilter
    $page: Int
    $limit: Int
  ) {
    processingTypes(sortBy: $sortBy, filter: $filter, page: $page, limit: $limit) {
      collection {
        id
        projectId
        title
        accessibleFor
        category
      }
      metadata {
        totalCount
      }
    }
  }
`
